import React from 'react';
import { Loading } from 'shared';
import { useLoadingPageStyles } from './loading.styles';

export function LoadingPage() {
  const classes = useLoadingPageStyles();
  return <Loading className={classes.loading} />;
}
